import { useContext, createContext } from 'react'
import { initialState } from '../reducer/checkReducer'
import { actionTypes } from '../types/actionTypes'
import { ReducerCheckState } from '../types/reducerTypes'

/*
 * Copyright 2022-07-26 por Alfonso Moya Ecomsur Holding S.A ©
 * Detalle: se crea useCheck por cambio a useReducer + Context
 */

interface CheckContext {
  state: ReducerCheckState
  dispatch: React.Dispatch<actionTypes>
}

// Se crea un Contexto el cual le asignamos el tipo de CountContext el cual tendra nuestro state del reducer y nuestro dispatch
export const CheckContext = createContext<CheckContext>({
  state: initialState,
  dispatch: () => {}
})

// Se crea un custom hook para validar que nuestro contexto no contenta una instancia indefinida
// y una vez se valide que si contiene una instancia, lo retornamos para su uso posterior

export const useCheck = () => {
  const context = useContext(CheckContext)
  if (context === undefined) {
    throw new Error('useCheck must be used within a Provider')
  }

  return context
}
